
import TitleService from 'title-service';
import './SeamlessControllerContainer.scss';
export default function SeamlessControllerContainer(props: {
    ended: boolean, ending: boolean, children: any,
    showControls: boolean,
    backgroundImage: string,
    hasNextEpisode: boolean
}) {
    if (!props.ended && !props.ending && props.showControls) {
        return <></>
    }
    return (
        <div className="thisone nfa-pos-abs nfa-top-0 nfa-left-0 nfa-right-0 nfa-bot-0 nfa-d-flex
     nfa-ai-flex-end nfa-jc-flex-end SeamlessControls--container SeamlessControls--container-visible">
            {props.ended && <div className="SeamlessControls--background-artwork SeamlessControls--background-artwork-visible" style={{
                "backgroundImage": `url('${props.backgroundImage}')`
            }}>
            </div>}
            <div className="nfa-pos-abs nfa-bot-6-em nfa-right-5-em nfa-d-flex ">
                {props.children}
            </div>
            {props.hasNextEpisode && <button className="touchable PlayerControls--control-element nfp-button-control circle-control-button button-nfplayerBack tooltip-button tooltip-button-pos-center tooltip-button-align-right"
                data-tooltip={TitleService("Return to navigation")}
            data-uia="nfplayer-exit" tabIndex={0}
            role="button" aria-label={TitleService("Return to navigation")}
            style={{ "display": "none" }}>
        </button>}
        </div >
    );
}